import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  LinearProgress,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const ApprovalWorkflowDialog: FC<any> = ({
  openApproveDialog,
  setOpenApproveDialog,
  buttonText,
  setDisableButton,
  setIsSentToTMF,
  taskId,
  taskTitle
}: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [comment, setComment] = useState<string>('');
  const [isProcessing, setProcessing] = React.useState<boolean>(false);
  const [issue, setIssue] = useState<string>('');
  const [type, setType] = useState<string>('');
  const [subType, setSubType] = useState<string>('');
  const [artifact, setArtifact] = useState<string>('');
  const [artifactNumber, setArtifactNumber] = useState<string>('');
  const isfLevel = 'Site';
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const entity = documentDetail?.data[0]?.isf_document_name;

  const dispatch = useDispatch();
  const handleCloseRejectDialog = () => {
    setOpenApproveDialog(false);
  };

  const getDocumentInfo = async (documentID: string) => {
    const res = await docService.getDocumentInfo(
      documentID,
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentApproval',
      entity
    );
    console.log('res', res);
    if (res.data) {
      setType(res.data.tmf_type);
      setSubType(res.data.tmf_subtype);
      setArtifact(res.data.tmf_artifact_name);
      setArtifactNumber(res.data.tmf_artifact_number);
    }
  };

  useEffect(() => {
    getDocumentInfo(documentDetail.data[0]?.id);
  }, []);

  const handleConfirmClick = async () => {
    setProcessing(true);
    const CompleteApprovalData = {
      action_name: 'Approve',
      is_resolved: true,
      updated_by: userName
    };

    const RejectApprovalData = {
      user_name: 'user',
      user_email_id: 'user@example.com',
      action_name: 'Review Feedback',
      feedback_comment: comment,
      updated_by: userName
    };

    if (buttonText === 'Review Feedback') {
      const response = await docService.reviewFeedback(
        documentDetail.data[0]?.task_Id ? documentDetail.data[0]?.task_Id : taskId,
        RejectApprovalData,
        selectedStudy,
        selectedCountry,
        selectedSite,
        isfLevel,
        process.env.REACT_APP_NAME,
        'DocumentApproval',
        entity
      );
      if (response?.data) {
        store.dispatch(setSnackbarMessage('Approve Rejected.', 'success'));
        setDisableButton(true);
        if (documentDetail?.data[0]?.need_sent_to_tmf === 'Yes' ? true : false) {
          if (documentDetail?.data[0].isf_doc_viewer_includes_phi) {
            if (documentDetail?.data[0].isf_doc_viewer_doc_phi_redacted !== 'N') {
              setIsSentToTMF(false);
            } else {
              setIsSentToTMF(true);
            }
          }
        } else {
          setIsSentToTMF(true);
        }
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            isf_doc_status: 'Rejected'
          }
        ]);
        const data = {
          is_resolved: false,
          action_name: 'Reject',
          updated_by: userName
        };
        const result: any = await docService.updateStatus(
          documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
          data,
          selectedStudy,
          selectedCountry,
          selectedSite,
          isfLevel,
          process.env.REACT_APP_NAME,
          'DocumentReview',
          entity
        );
      } else {
        store.dispatch(setSnackbarMessage('Error in Rejecting.', 'error'));
      }
    } else {
      const result = await docService.sendToTMF(
        documentDetail.data[0]?.task_Id ? documentDetail.data[0]?.task_Id : taskId,
        CompleteApprovalData,
        selectedStudy,
        selectedCountry,
        selectedSite,
        isfLevel,
        process.env.REACT_APP_NAME,
        'DocumentApproval',
        entity,
        false
      );

      const query = {
        query_filters: [
          {
            name: 'isf_document_id',
            value: documentDetail?.data[0]?.isf_document_id,
            operation: 'equals'
          }
        ],
        filter_types: ['All']
      };
      const res: any = await docService.getSearchResult(
        query,
        selectedStudy,
        selectedCountry,
        selectedSite,
        isfLevel,
        selectedStudy === '--' ? false : true,
        process.env.REACT_APP_NAME,
        'DocumentApproval',
        entity
      );

      if (result.data) {
        store.dispatch(setSnackbarMessage('Approved successfully.', 'success'));
        setDisableButton(true);
        if (res?.data?.selected_data[0]?.need_sent_to_tmf === 'Yes' ? true : false) {
          if (res?.data?.selected_data[0]?.document_data?.isf_doc_viewer_includes_phi) {
            if (res?.data?.selected_data[0]?.document_data?.isf_doc_viewer_doc_phi_redacted !== 'N') {
              setIsSentToTMF(false);
            } else {
              setIsSentToTMF(true);
            }
          }
        } else {
          setIsSentToTMF(true);
        }
        setDocumentDetail(dispatch, [
          {
            ...documentDetail.data[0],
            isf_doc_status: 'Approved',
            isf_doc_approval_date: res?.data?.selected_data[0]?.document_data.isf_doc_approval_date
          }
        ]);
      } else {
        store.dispatch(setSnackbarMessage('Error in approving.', 'error'));
      }
    }
    setProcessing(false);

    setOpenApproveDialog(false);
  };

  const handleComment = (e: any) => {
    setComment(e.target.value);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIssue(event.target.value);
  };
  return (
    <React.Fragment>
      <PopupComponent
        open={openApproveDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {buttonText === 'Review Feedback' ? 'Review Feedback' : 'Approve'}
        </DialogTitle>
        <DialogContent sx={{ minWidth: 420, maxWidth: 440 }}>
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <DialogContentText
            id="alert-dialog-description"
            sx={{ color: 'rgba(0,0,0,0.87)', fontSize: 16, '& p, & ~p': { fontSize: 16 } }}
          >
            <Typography variant="body1">
              {buttonText === 'Review Feedback'
                ? `Are you sure you would like to send feedback on this document?`
                : // : `Are you sure you want to send the document to TMF?`
                  ''}
            </Typography>
          </DialogContentText>
          <br></br>
          <Typography style={{ fontWeight: 'bold' }}>
            {`'${documentDetail.data[0]?.task_title ? documentDetail.data[0]?.task_title?.trim() : taskTitle}'`}
            <span style={{ fontWeight: 200 }}>
              {''}
              {buttonText === 'Review Feedback'
                ? ' task will be send back to the uploader.'
                : ' task will be marked as completed.'}
            </span>
          </Typography>
          {buttonText === 'Review Feedback' ? (
            <Grid container mt={2}>
              <Grid md={12} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <TextField
                    id="standard-basic"
                    label="Feedback Comment"
                    variant="standard"
                    value={comment}
                    required
                    inputProps={{
                      maxLength: 300
                    }}
                    onChange={e => handleComment(e)}
                    //disabled={!checkPermission('update_qc_details')}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions sx={{ '& .MuiButton-root': { fontSize: 14, fontWeight: 700 } }}>
          <Button onClick={handleCloseRejectDialog} className="grey-btn" disabled={isProcessing}>
            CLOSE
          </Button>
          <Button
            onClick={() => handleConfirmClick()}
            autoFocus
            disabled={buttonText === 'Review Feedback' ? (comment.trim() === '' ? true : false) : false || isProcessing}
          >
            CONFIRM
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default React.memo(ApprovalWorkflowDialog);
